module.exports = __webpack_public_path__ + "static/media/about-us2.29247505.png";